import { Component, inject, input, output } from '@angular/core';
import { IReferral } from '../referral-list/referral-list.interface';
import { User } from '../../../types/user.model';
import { UserAvatarV2Component } from '../../user-avatar-v2/user-avatar-v2.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { enUS, es } from 'date-fns/locale';
import { format } from 'date-fns';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'app-referral-list-ganasocios',
  imports: [UserAvatarV2Component, TranslatePipe, NzCheckboxModule],
  templateUrl: './referral-list-ganasocios.component.html',
  styleUrl: './referral-list-ganasocios.component.scss'
})
export class ReferralListGanasociosComponent {
  #translateService = inject(TranslateService);

  items = input<IReferral[]>([]);
  selectionEnabled = input(false);
  selectedReferralIds = input<ReadonlySet<number>>(new Set<number>());
  referralClick = output<number>();
  selectedReferralIdsChange = output<ReadonlySet<number>>();

  public getLastContactedDate(date: string): string {
    const locale: Locale = this.#translateService.currentLang === 'es' ? es : enUS;
    const formattedDate: string = format(new Date(date), 'MMM d', { locale });
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  }

  referralAsUser(referral: IReferral): User {
    return new User({ ...referral, status: referral.status.name });
  }

  onReferralClick(referral: IReferral): void {
    this.referralClick.emit(referral.id);
  }

  onItemCheck(referralId: number, checked: boolean): void {
    const selectedReferralIds = new Set<number>(this.selectedReferralIds());

    if (checked) {
      selectedReferralIds.add(referralId);
    } else {
      selectedReferralIds.delete(referralId);
    }

    this.selectedReferralIdsChange.emit(selectedReferralIds);
  }
}
